import styled, { css } from 'styled-components';
import { white, gray10, gray75 } from '@spotify-internal/tokens';

export const Container = styled.div`
  background: ${white};
  display: flex;
  flex-direction: column;
  left: 0;
  min-height: 100%;
  position: absolute;
  top: 0;
  width: 100%;

  ${props =>
    props.theme.app === 'dark' &&
    css`
      background: ${gray10};
      color: ${gray75};

      /* TODO: figure out a better way to do default links */
      a[href]:not([class]) {
        color: ${white};
        text-decoration: none;

        &:hover,
        &:focus {
          color: ${white};
          text-decoration: underline;
        }

        &:active {
          color: ${white};
        }

        &:focus {
          /* Default */
          outline: thin dotted;
          /* WebKit */
          outline: 5px auto -webkit-focus-ring-color;
          outline-offset: -2px;
        }
      }
    `};
`;
